import { render, staticRenderFns } from "./SessionHistoryContainer.vue?vue&type=template&id=2d124064&scoped=true&"
import script from "./SessionHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./SessionHistoryContainer.vue?vue&type=script&lang=js&"
import style0 from "./SessionHistoryContainer.vue?vue&type=style&index=0&id=2d124064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d124064",
  null
  
)

export default component.exports